import Badge from "components-new/Badge";
import { FC, useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ActionMenuIcon from "../../images/ActionMenuIcon.svg";
import { ReactComponent as DeleteIconSvg } from "images/TrashCan.svg";
import { ReactComponent as Exclamation } from "images/Exclamation.svg";
import { ReactComponent as ReestablishIconSvg } from "images/reestablish.svg";
import DropSelect from "components-new/DropSelect";
import { archiveEmployee, deleteFromArchiveEmployee } from "toolkit/employees/employees.thunks";
import { useAppDispatch } from "toolkit/hooks";

import "./StaffListItem.styles.sass";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import { snackWrapper } from "../../helpers";
import Tooltip from "components-new/Tooltip";
import {userAPI} from "../../libs/apiClient/User";

interface StaffListItemProps {
	archive: boolean;
	select: boolean;
	employee: any;
	outline: (id: number) => string;
	read: boolean;
}

export const StaffListItem: FC<StaffListItemProps> = ({ employee, read, archive, select, outline }) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const actionsRef = useRef(null);
	const [actionsVisible, setActionsVisible] = useState<boolean>(false);

	const locationState = useLocation().state;

	useEffect(() => {
		const handler = () => {
			setActionsVisible(false);
		};

		document.body.addEventListener("click", handler);

		return () => {
			document.body.removeEventListener("click", handler);
		};
	});

	const deleteEmployee = (employeeId: number) => {
		if (archive) {
			dispatch(deleteFromArchiveEmployee(employeeId));
		} else {
			dispatch(archiveEmployee(employeeId));
		}
	};

	useOutsideAlerter(actionsRef.current, () => setActionsVisible(false));

	const connectEntity = useCallback(() => {
		if (select) {
			const params = { employeeid: employee.id, userid: locationState.id };
			userAPI.profileBindList(params).then(() => navigate(-1));
		}
		//eslint-disable-next-line
	}, [locationState]);
	const needRule = () => {
		snackWrapper("error", "Не достаточно прав");
	};
	return (
		<tr className={`staff-table-body-row ${outline(employee.id)}`} onClick={connectEntity}>
			<td className="staff-table-body-row-item">
				{select ? (
					<span>{employee.fullName}</span>
				) : read ? (
					<Link to={`/employee/${employee.id}`} className="staff-table-body-row-item-link">
						{employee.fullName}
					</Link>
				) : (
					<span onClick={needRule}>{employee.fullName}</span>
				)}
			</td>
			<td className="staff-table-body-row-item">{employee.tabNumber || "—"}</td>
			<td className="staff-table-body-row-item">{employee.relationship || "—"}</td>
			<td className="staff-table-body-row-item">{employee.position || "—"}</td>
			<td className="staff-table-body-row-item">{employee.department || "—"}</td>
			<td className="staff-table-body-row-item">{employee.employmentDate || "—"}</td>
			<td className="staff-table-body-row-item">{employee.dismissalDate || "—"}</td>
			{!archive && (
				<td className="staff-table-body-row-item">
					<Badge type="info">{employee.status}</Badge>
				</td>
			)}
			<td className="staff-table-body-row-item staff-table-body-row-item-wrp">
				{employee.organization?.archived && (
					<div>
						<Tooltip
							delay={200}
							menu={<div className="staff-table-body-row-item-tooltip">Организация в архиве</div>}
							color="themeWhite">
							<Exclamation className="staff-table-body-row-item-exclamation" />
						</Tooltip>
					</div>
				)}

				{employee.organization && employee.organization.id
					? // <Link
					  //   to={`/organization/${employee.organization.id}`}
					  //   className="staff-table-body-row-item-link"
					  // >
					  employee.organization.shortName
					: // </Link>
					  "—"}
			</td>
			<td className="staff-table-body-row-item">
				<button
					onClick={(e) => {
						e.stopPropagation();
						setActionsVisible(!actionsVisible);
					}}
					className="staff-table-body-row-item-btn">
					{!select && <img src={ActionMenuIcon} alt="menu" width={28} height={28} ref={actionsRef} />}
				</button>
				<div className="staff-table-action-menu-wrp">
					{actionsVisible && (
						<DropSelect target={actionsRef.current} position="right">
							<div className="staff-table-action-menu">
								<button className="staff-table-action-menu-btn" onClick={() => deleteEmployee(employee.id)}>
									{archive ? (
										<>
											<div>
												<ReestablishIconSvg className="staff-table-action-menu-btn-reestablishIcon" />
											</div>
											<span className="staff-table-action-menu-btn-txt">Восстановить</span>
										</>
									) : (
										<>
											<div>
												<DeleteIconSvg className="staff-table-action-menu-btn-deleteIcon" />
											</div>
											<span className="staff-table-action-menu-btn-txt">Переместить в архив</span>
										</>
									)}
								</button>
							</div>
						</DropSelect>
					)}
				</div>
			</td>
		</tr>
	);
};
